import _regeneratorRuntime from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/root/.jenkins/workspace/prod-dapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { getUsdToWeis, chainList, getChainGasPrice } from '@/utils/connect';
export default {
  name: 'numberSkeleton',
  props: {
    price: {
      modelValue: String
    },
    isDutchAuction: {
      modelValue: Boolean,
      "default": false
    },
    currencySelect: {
      modelValue: Object,
      "default": {}
    },
    priceOg: {
      modelValue: Number,
      "default": 0
    },
    usdPrice: {
      modelValue: Number,
      "default": 0
    }
  },
  watch: {
    usdPrice: {
      handler: function handler(to, from) {
        if (to) {}
      },
      deep: true,
      immediate: false
    }
  },
  data: function data() {
    return {
      theUsdPrice: ''
    };
  },
  computed: {
    isLoading: function isLoading(usdPrice, e) {
      return function (usdPrice, e) {
        usdPrice = usdPrice.toString();
        if (usdPrice) {
          if (usdPrice == '0' && e) {
            return false;
          }
          if (usdPrice.indexOf('NaN') != -1 || usdPrice == '0') {
            return true;
          }
          return usdPrice ? false : true;
        }
        return true;
      };
    }
  },
  mounted: function mounted() {},
  methods: {
    getUseNum: function getUseNum(num) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getUsdToWeis(num);
            case 2:
              res = _context.sent;
              return _context.abrupt("return", "\u2248 ".concat(res).concat(_this.getsSmbol()));
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    getsSmbol: function getsSmbol() {
      try {
        if (this.$store.state.chainid) {
          return chainList[this.$store.state.chainid].nativeCurrency.name;
        } else {
          return '';
        }
      } catch (error) {
        return '';
      }
    }
  }
};